// extracted by mini-css-extract-plugin
export var button = "_dq-4";
export var hasDarkBackground = "_dq-7";
export var hasLightBackground = "_dq-6";
export var iconWrapper = "_dq-0";
export var large = "_dq-2";
export var medium = "_dq-1";
export var small = "_dq-5";
export var xsmall = "_dq-3";